import styled from 'styled-components';

export const StyledSearchUrlForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;
